<div class="export-stock-drawer">
    <div class="drawer-content">
        <p class="description">{{ 'pages.stock.export.description' | translate }}</p>

        <div class="context-summary" *ngIf="selectedStoreSummary || selectedProductSummary">
            <span class="context-summary__title">{{ 'pages.stock.export.filtersTitle' | translate }}</span>
            <div class="context-summary__chips">
                <span class="context-chip" *ngIf="selectedStoreSummary">
                    <span class="context-chip__label">{{ 'pages.stock.export.filter.store' | translate }}:</span>
                    <span class="context-chip__value">{{ selectedStoreSummary }}</span>
                </span>
                <span class="context-chip" *ngIf="selectedProductSummary">
                    <span class="context-chip__label">{{ 'pages.stock.export.filter.search' | translate }}:</span>
                    <span class="context-chip__value">{{ selectedProductSummary }}</span>
                </span>
            </div>
        </div>

        <!-- Export type -->
        <section class="form-section" aria-labelledby="export-type-label">
            <label id="export-type-label" class="section-label">
                {{ 'pages.stock.export.whatToExport' | translate }}
            </label>

            <div class="export-options" role="radiogroup" aria-labelledby="export-type-label">
                <!-- ALL -->
                <button type="button" class="export-option" [class.is-selected]="selectedExportType === 'all'"
                    role="radio" [attr.aria-checked]="selectedExportType === 'all'" (click)="onExportTypeChange('all')">
                    <span class="radio" aria-hidden="true">
                        <span class="radio__dot" *ngIf="selectedExportType === 'all'"></span>
                    </span>

                    <span class="option-content">
                        <span class="option-title">
                            {{ 'pages.stock.export.options.all.title' | translate }}
                        </span>
                        <span class="option-description">
                            {{ 'pages.stock.export.options.all.description' | translate }}
                        </span>
                    </span>
                </button>

                <!-- STORE (not in storage detail) -->
                <button *ngIf="!isStorageDetailContext" type="button" class="export-option"
                    [class.is-selected]="selectedExportType === 'store'" role="radio"
                    [attr.aria-checked]="selectedExportType === 'store'" (click)="onExportTypeChange('store')">
                    <span class="radio" aria-hidden="true">
                        <span class="radio__dot" *ngIf="selectedExportType === 'store'"></span>
                    </span>

                    <span class="option-content">
                        <span class="option-title">
                            {{ 'pages.stock.export.options.store.title' | translate }}
                        </span>
                        <span class="option-description">
                            {{ 'pages.stock.export.options.store.description' | translate }}
                        </span>
                    </span>
                </button>

                <!-- PRODUCT -->
                <button type="button" class="export-option" [class.is-selected]="selectedExportType === 'product'"
                    role="radio" [attr.aria-checked]="selectedExportType === 'product'"
                    (click)="onExportTypeChange('product')">
                    <span class="radio" aria-hidden="true">
                        <span class="radio__dot" *ngIf="selectedExportType === 'product'"></span>
                    </span>

                    <span class="option-content">
                        <span class="option-title">
                            {{ 'pages.stock.export.options.product.title' | translate }}
                        </span>
                        <span class="option-description">
                            {{ 'pages.stock.export.options.product.description' | translate }}
                        </span>
                    </span>
                </button>
            </div>
        </section>

        <!-- Stores selector -->
        <section class="form-section"
            *ngIf="(selectedExportType === 'store' || selectedExportType === 'product') && !isStorageDetailContext"
            aria-labelledby="stores-label">
            <label id="stores-label" class="section-label">
                {{ 'pages.stock.export.selectStores' | translate }}
            </label>

            <app-reusable-searcher #storeSearcher [displayField]="'name'" [valueField]="'id'"
                [placeholder]="'pages.stock.export.selectStoresPlaceholder' | translate"
                (search)="onStoreSearch($event)" (itemSelected)="onStoreSelected($event)" [showAbove]="false"
                [clearOnSelect]="true">
            </app-reusable-searcher>

            <span class="helper-text" *ngIf="isLoadingStores">
                {{ 'pages.stock.export.loadingStores' | translate }}
            </span>

            <span class="error-text" *ngIf="showStoreError">
                {{ 'pages.stock.export.validation.storeRequired' | translate }}
            </span>

            <div class="chips" *ngIf="selectedStores.length > 0"
                [attr.aria-label]="'pages.stock.export.selectStores' | translate">
                <span class="chip" *ngFor="let store of selectedStores; trackBy: trackByStoreId">
                    <span class="chip__text">{{ store.name }}</span>
                    <button type="button" class="chip__remove" (click)="removeStore(store)"
                        [attr.aria-label]="'pages.stock.export.removeStoreAria' | translate : { name: store.name }">
                        ×
                    </button>
                </span>
            </div>
        </section>

        <!-- Products selector -->
        <section class="form-section" *ngIf="selectedExportType === 'product'" aria-labelledby="products-label">
            <label id="products-label" class="section-label">
                {{ 'pages.stock.export.selectProducts' | translate }}
            </label>

            <app-reusable-searcher #productSearcher [displayField]="'productName'" [valueField]="'productId'"
                [placeholder]="'pages.stock.export.selectProductsPlaceholder' | translate"
                (search)="onProductSearch($event)" (itemSelected)="onProductSelected($event)" [showAbove]="false"
                [clearOnSelect]="true">
            </app-reusable-searcher>

            <span class="helper-text" *ngIf="isLoadingProducts">
                {{ 'pages.stock.export.loadingProducts' | translate }}
            </span>

            <span class="error-text" *ngIf="showProductError">
                {{ 'pages.stock.export.validation.productRequired' | translate }}
            </span>

            <div class="chips" *ngIf="selectedProducts.length > 0"
                [attr.aria-label]="'pages.stock.export.selectProducts' | translate">
                <span class="chip" *ngFor="let product of selectedProducts; trackBy: trackByProductId">
                    <span class="chip__text">{{ product.productName }}</span>
                    <button type="button" class="chip__remove" (click)="removeProduct(product)"
                        [attr.aria-label]="'pages.stock.export.removeProductAria' | translate : { name: product.productName }">
                        ×
                    </button>
                </span>
            </div>
        </section>
    </div>

    <!-- Footer -->
    <footer class="form-actions">
        <div class="form-actions__inner">
            <button type="button" class="download-btn" [class.is-loading]="isExporting" [class.is-disabled]="!canExport"
                [attr.aria-disabled]="!canExport" [disabled]="!canExport" (click)="downloadFile()">
                <span class="spinner" *ngIf="isExporting" aria-hidden="true"></span>
                <img *ngIf="!isExporting" src="/assets/icons/backoffice/download.svg" alt="" class="download-icon" />
                <span>
                    {{ (isExporting ? 'pages.stock.export.downloading' : 'pages.stock.export.downloadButton') |
                    translate }}
                </span>
            </button>
        </div>
    </footer>
</div>